module.exports = {
      id: "check-circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#check-circle",
      toString: function () {
        return this.url;
      }
    }